import React from 'react';
import { Link } from 'react-router-dom';
 
class Footer extends React.Component {
    render(){
        return (
            <footer className="footer-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="single-footer-widget">
                                <h3>Fechas y ubicación</h3>
                                <span>
                                    <i className="icofont-calendar"></i> 14-15 Octubre, 2022
                                </span>

                                <p className="location">
                                    <i className="icofont-google-map"></i> Colegio Monte Tabor Schoenstatt, Pozuelo de Alarcón, España
                                </p>

                                <p className="contact-authority">
                                    <i className="icofont-phone"></i> Contacto: 676931212   
                                </p>

                                <p className="contact-authority">
                                    <i className="icofont-email"></i> congreso@colegiomontetabor.es  
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="single-footer-widget">
                                <h3>Redes</h3>
                                <p>Manténte al día de nuestras novedades.</p>
                                
                                <ul className="social-links">
                                   {/*  <li>
                                        <Link to="https://www.facebook.com/" className="facebook" target="_blank">
                                            <i className="icofont-facebook"></i>
                                        </Link>
                                    </li> */}
                                    {/* <li>
                                        <Link to="https://twitter.com/" className="twitter" target="_blank">
                                            <i className="icofont-twitter"></i>
                                        </Link>
                                    </li> */}
                                    <li>
                                        <a href="https://www.linkedin.com/in/colegio-monte-tabor-schoenstatt-madrid-b33974231" className="linkedin" target="_blank">
                                            <i className="icofont-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/congresoeducacionorganica" className="instagram" target="_blank">
                                            <i className="icofont-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="copyright-area">
                                <div className="logo">
                                    <Link to="/">
                                        <img src={require("../../assets/images/logo.png")} alt="logo" />
                                    </Link>
                                </div>
                                <ul>
{/*                                     <li><Link to="/contact">Contact</Link></li> */}
                                    <li><Link to="/horario">Horario</Link></li>
                                    <li><Link to="/ponentes">Ponentes</Link></li>
                                    <li><Link to="/talleres">Talleres</Link></li>
                                    <li><Link to="/patrocinadores">Patrocinadores</Link></li>
{/*                                     <li><Link to="/ponentes">Ponentes</Link></li>*/}
                                    <li><Link to="/inscripcion">Inscripción</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}
 
export default Footer;